import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { App } from './App';

const isDev = import.meta.env.DEV;

ReactDOM.createRoot(document.getElementById('root')!).render(
  isDev ? (
    <StrictMode>
      <App />
    </StrictMode>
  ) : (
    <App />
  ),
);
